import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../../reducer/CombineReducer";
import { useUser } from "../../../../AuthContext";
import { CreateVersionButtonView } from "./CreateVersionButton.view";
import { VersioningSlice } from "./redux";
import { GetVersioning } from "./Scripts";

/**
 * Responsible for rendering the create version button
 */
export const CreateVersionButton: React.FC = () => {

  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const [
    extractState,
    versioning
  ] = useSelector((state: IRootState) => [
    state.extractState,
    state.versioning
  ], shallowEqual);
  const extractGuid = extractState.selectedExtract?.extractGuid as string;
  const exportStatus = versioning?.exportStatus;
  const { user } = useUser();
  const env = process.env.APP_TARGET_ENV as Environments;

  /**
   * Handler for creating the new version
   */
  const onCreateNewVersion = (): void => {
    dispatch(VersioningSlice.actions.showDialog(true));
  };

  /**
   * Method for refresh button click
   */
  const onRefreshClick = (): void => {
    GetVersioning(dispatch, translate, env, user?.token, extractGuid, exportStatus.currentVersion);
  };

  /**
   * The below commented code will be used while implementing export API
   */
  // Const toShowRefresh = extractVersions?.some((item: VersionListType) =>
  //   Item.versioningStatus === ExportStatus.INPROGRESS ||
  //   (item.exportStatus === ExportStatus.INPROGRESS || exportStatus.status === ExportStatus.INPROGRESS));

  return (
    <CreateVersionButtonView
      onClick={onCreateNewVersion}
      onRefreshClick={onRefreshClick}
      toShowRefresh={true}
    />
  );
};
